import { Badge } from 'DesignSystem/ui/badge';
import type { DohRollup } from 'pages/disruption/types';

import { DOH_CARDS } from './event-items-doh';

type EventItemsDohCardsProps = {
  dohRollup?: DohRollup;
};

export default function EventItemsDohCards({ dohRollup }: EventItemsDohCardsProps) {
  return (
    <div className="grid grid-cols-3 gap-4">
      {DOH_CARDS.map((card) => (
        <div key={card.key} className="rounded-lg border border-zinc-200 bg-white p-4">
          <div className="type-body-xs text-zinc-500">{card.label}</div>
          <div className="mt-2 flex items-center gap-2">
            <span className="type-body-2xl font-medium text-zinc-900">{dohRollup?.[card.key] ?? 0}</span>
            <Badge variant="custom" className={card.badgeClassName}>
              {card.badge}
            </Badge>
          </div>
        </div>
      ))}
    </div>
  );
}
